// Module-level preview-token accessor, mirroring the auth-token pattern.
// Registered synchronously by PreviewSessionProvider so axios interceptors
// and direct fetch callers can always reach the active token.

type TokenGetter = () => string | null | undefined;

let _getter: TokenGetter | null = null;

export function setPreviewTokenGetter(getter: TokenGetter): void {
  _getter = getter;
}

export function getPreviewToken(): string | null {
  if (!_getter) return null;
  return _getter() ?? null;
}
